module.exports = __webpack_public_path__ + "img/오딘.d7ab3e63.jpg";